import { render, staticRenderFns } from "./SidebarSection.vue?vue&type=template&id=11e2b24b&scoped=true"
import script from "./SidebarSection.vue?vue&type=script&lang=js"
export * from "./SidebarSection.vue?vue&type=script&lang=js"
import style0 from "./SidebarSection.vue?vue&type=style&index=0&id=11e2b24b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e2b24b",
  null
  
)

export default component.exports